<template>
<div>
  <el-form style="margin-right: 30px" :model="addEditForm" :rules="addEditRules" ref="addEditForm" label-width="110px" class="demo-ruleForm">
    <el-form-item label="用户姓名" prop="name">
      <el-input v-model="addEditForm.name" placeholder="请输入"></el-input>
    </el-form-item>
  </el-form>
  <div style="height: 60px">
    <el-row style="margin: 0 40px">
      <el-col :span="12">
        <div class="cancel-btn" @click="closeOpen()">
          <span>取消</span>
        </div>
      </el-col>
      <el-col :span="12">
        <div class="send-btn" @click="commitInfo('addEditForm')">
          <span>确定</span>
        </div>
      </el-col>
    </el-row>
  </div>
</div>
</template>
<script>
export default {
  name: 'addEditUser',
  model: {
    prop: 'addEditShow',
    event: 'change'
  },
  props: {
    addEditRow: {
      type: Object,
      default: null
    }
  },
  data () {
    return {
      addEditForm: {
        name: ''
      },
      addEditRules: {
        name: [
          { required: true, message: '请输入', trigger: 'blur' }
        ]
      }
    }
  },
  created () {
    if (!this.addEditRow.isAdd) {}
  },
  methods: {
    closeOpen () {
      this.$emit('change', false)
    },
    commitInfo (formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.$emit('change', false)
        } else {
          console.log('error submit!!')
          return false
        }
      })
    }
  }
}
</script>
<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/businessWeChat/businessComponents/addEditUser.vue